/* ============================================================
 * WIREDAN AGRI-PULSE: Global Entry Point (V12.1.2)
 * Status: STABLE | CONTEXT-WRAPPED | PWA-ENABLED
 * Update: Global Vision Resampling & Identity Lock Sync
 * ============================================================
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';

// Context Providers
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext'; 
import { SatelliteProvider } from './context/SatelliteContext'; 

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Prevents excessive imagery API calls
      retry: 1
    }
  }
});

/**
 * SERVICE WORKER: Background Sync & PWA Engine
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('🛡️ Agri-Pulse: Background Engine Active');
        return navigator.serviceWorker.ready;
      })
      .then(() => {
        console.log('⚡ Agri-Pulse: Background Sync Ready');
      })
      .catch((error) => {
        console.error('❌ Service Worker Registration Failed:', error);
      });
  });
}

// Inject Global Vision Resampling Hint
// This ensures the "Clean View" math from the canvas stays crisp globally
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `
    canvas, img { 
      image-rendering: -webkit-optimize-contrast; 
      image-rendering: auto; 
    }
  `;
  document.head.appendChild(style);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          {/* AuthProvider must be parent to SatelliteProvider for Identity Lock */}
          <AuthProvider>
            <SatelliteProvider>
              <App />
              <Toaster 
                position="top-right" 
                toastOptions={{
                  style: {
                    background: '#0B1221',
                    color: '#fff',
                    fontSize: '14px',
                    borderRadius: '8px',
                    border: '1px solid #1E293B'
                  },
                }}
              />
            </SatelliteProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);